// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import OEAccountLookupTemplate from '@front/templates/OEAccountLookupTemplate.html';
import { ContainerControl } from '@front/controls/elements/ContainerControl';
import { Resources } from '@shared/localizations/Resources';
import { ControlsTypes } from '@front/controls/UtilsClasses/FactoryConstants';
import { ResourcesManager } from '@shared/commons/properties/ResourcesManager';
export class OEAccountLookup extends ContainerControl {
    constructor() {
        super();
    }
    getType() {
        return ControlsTypes.OEAccountLookup;
    }
    oninit() {
        super.oninit();
        ResourcesManager.onLocaleChange.Subscribe(this.localize, this);
        this.localize();
    }
    dispose() {
        ResourcesManager.onLocaleChange.UnSubscribe(this.localize, this);
        super.dispose();
    }
    setFocus() {
        const enabled = this.get('enabled');
        if (!enabled) {
            return;
        }
        super.setFocus();
        if (!isNullOrUndefined(this.Controls.TerceraAccountLookup)) {
            this.Controls.TerceraAccountLookup.setFocus();
        }
    }
    localize() {
        void this.set('label', Resources.getResource('panel.newOrderEntry.accountLabel'));
    }
}
ContainerControl.extendWith(OEAccountLookup, {
    template: OEAccountLookupTemplate,
    data: function () {
        return {
            label: '',
            name: ControlsTypes.OEAccountLookup,
            account: null
        };
    }
});
